import { LabelProps } from '@components/label/label.type';

export const Label = ({ children, className, ...props }: LabelProps) => {
  return (
    <label className={className} {...props}>
      {children}
    </label>
  );
};
